import UTMGenerator from './components/UTMGenerator';

export default function App() {
  return (
    <div className="max-w-xl mx-auto p-6 space-y-6 text-gray-900">
      <h1 className="text-2xl font-bold">UTM URL Generator</h1>
      <UTMGenerator />
    </div>
  );
}
